/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import './styles.css'

export class CourseTabs extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.tabs !== this.props.tabs
  }

  render() {
    const { tabs, isSubscribed, isOwned } = this.props
    return (
      <section id="course-tabs" className={classnames('wrapper-1080', { 'on-side': isSubscribed || isOwned })}>
        <Tabs>
          <TabList>
            {tabs.map((tab) => (
              <Tab
                key={tab.name}
                title={`${tab.name[0].toUpperCase() + tab.name.substring(1)} - Use arrows to navigate between tabs`}
              >
                <span>{tab.name}</span>
              </Tab>
            ))}
          </TabList>

          {tabs.map((tab) => (
            <TabPanel key={tab.name} className={tab.name}>{tab.content}</TabPanel>
          ))}
        </Tabs>
      </section>
    )
  }
}

CourseTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      content: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    })
  ).isRequired,
  isSubscribed: PropTypes.bool,
  isOwned: PropTypes.bool
}

CourseTabs.defaultProps = {
  isSubscribed: false,
  isOwned: false
}

export default CourseTabs
